<div class="banner">
    <div class="col-12 pb-5"><h1>Suspicious Activity</h1></div>
    <div class="tab">
        <ul class="nav nav-tabs">
            <li><a [routerLink]="[{ outlets: { 'suspicious-activity-tab': ['carrier-reported-activities'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Carrier-Reported Activities</a></li>
            <li><a [routerLink]="[{ outlets: { 'suspicious-activity-tab': ['report-suspicious-activity'] } }]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Report Suspicious Activity</a></li>
        </ul>
    </div>
</div>
<div class="tabcontent">
    <router-outlet name="suspicious-activity-tab"></router-outlet>
</div>